// components/Sender/SenderPlanModal.js
import React, { useState, useEffect } from "react";
import { SenderApi } from "./SenderApi";

const MODE_LABEL = {
  EMAIL_ONLY: "📧 Email",
  CONTACT_FORM_ONLY: "📝 Форма",
  BOTH: "📧+📝 BOTH",
};

export function SenderPlanModal({ run, runId, onClose, add }) {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const p = runId
          ? await SenderApi.getPlanByRunId(runId)
          : await SenderApi.getPlan(run);
        if (!cancelled) setPlan(p);
      } catch (e) {
        if (!cancelled) {
          setErr(e.message);
          add?.("Не удалось получить план: " + e.message, "error");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runId, run]);

  return (
    <div style={overlay} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={card}>
        <div style={header}>
          <div>
            <h3 style={{ margin: 0 }}>🔍 Предпросмотр</h3>
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
              Оценка числа сообщений
            </div>
          </div>
          <button className="btn-cancel" onClick={onClose}>✕</button>
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: 20 }}>
          {loading && (
            <div style={{ textAlign: "center", padding: 40, color: "#6b7280" }}>
              ⏳ Считаем…
            </div>
          )}
          {err && (
            <div style={{ padding: 16, background: "#fee2e2",
                          color: "#b91c1c", borderRadius: 8 }}>
              ⚠️ {err}
            </div>
          )}
          {plan && (
            <>
              <table style={{
                width: "100%", borderCollapse: "collapse", fontSize: 13,
                marginBottom: 16,
              }}>
                <thead>
                  <tr style={{ background: "#f9fafb" }}>
                    {["#", "Сегмент", "Режим", "Таргетов",
                      "Интеншенов", "≈ Сообщений"].map((h) => (
                      <th key={h} style={thStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(plan.blocks || []).map((b) => (
                    <tr key={b.index} style={{ borderBottom: "1px solid #f3f4f6" }}>
                      <td style={tdStyle}>{b.index}</td>
                      <td style={tdStyle}>
                        {b.name}
                        {b.error && (
                          <span style={{ color: "#dc2626", marginLeft: 6 }}>
                            ⚠️ {b.error}
                          </span>
                        )}
                      </td>
                      <td style={tdStyle}>{MODE_LABEL[b.mode] || b.mode}</td>
                      <td style={tdStyle}>{b.intentions ?? 0}</td>
                      <td style={tdStyle}>
                        {b.raw_intentions ?? b.intentions ?? 0}
                      </td>
                      <td style={{ ...tdStyle, fontWeight: 700 }}>
                        {b.messages ?? 0}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{
                padding: 14, background: "#eef2ff",
                borderRadius: 10, color: "#3730a3", fontSize: 13,
                lineHeight: 1.6,
              }}>
                <div style={{ fontSize: 16, fontWeight: 700 }}>
                  Итого: {plan.total || 0} сообщений
                </div>
                {plan.total_limit && plan.raw_total > plan.total_limit && (
                  <div style={{ color: "#b45309", marginTop: 4 }}>
                    Ограничено общим лимитом ({plan.total_limit});
                    без лимита было бы {plan.raw_total}
                  </div>
                )}
                <div style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>
                  ⚠️ Это оценка сверху. Реальное число меньше.
                </div>
              </div>
            </>
          )}
        </div>

        <div style={footer}>
          <button className="btn-primary" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,.6)",
  backdropFilter: "blur(3px)", zIndex: 1200,
  display: "flex", alignItems: "center", justifyContent: "center",
  padding: 20 };
const card = { background: "#fff", borderRadius: 14, width: "100%",
  maxWidth: 900, maxHeight: "90vh", display: "flex",
  flexDirection: "column", overflow: "hidden" };
const header = { padding: "16px 20px", borderBottom: "1.5px solid #e5e7eb",
  display: "flex", justifyContent: "space-between", alignItems: "center" };
const footer = { padding: "12px 20px", borderTop: "1.5px solid #e5e7eb",
  display: "flex", justifyContent: "flex-end" };
const thStyle = { textAlign: "left", padding: "8px 10px",
  borderBottom: "1.5px solid #e5e7eb", color: "#6b7280",
  fontWeight: 600, fontSize: 11, textTransform: "uppercase",
  letterSpacing: ".03em" };
const tdStyle = { padding: "8px 10px" };